import { Paper } from '@e3dc-react/shell/Elements/Paper'
import React from 'react'
import { useActuatorBaseStyles } from './ActuatorBase'
import { Stack } from '@mui/material'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { Actuator } from '../../models/smart-home.model'

interface Props {
  actuator: Actuator
  headerContent: React.ReactNode
  children?: React.ReactNode
}

/**
 * Base component for wireless actors that need multiple lines in the UI, e.g. to display multiple options or a more complex form.
 */
const MultilineActorBase: React.FC<Props> = ({ actuator, headerContent, children }) => {
  const { classes } = useActuatorBaseStyles()

  return (
    <Paper className={classes.paper}>
      <Stack flexDirection={'row'} gap={2} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }}>
        <Typography variant="h3">{actuator.name}</Typography>
        {headerContent}
      </Stack>
      {children}
    </Paper>
  )
}

export default MultilineActorBase
